import React from "react";
import { format } from "date-fns";
import { CurrencyRupeeIcon, CheckCircleIcon, ClockIcon, XCircleIcon } from "@heroicons/react/outline";

const PaymentCard = ({ payment, showPlan = true, onClick }) => {
  const getStatusIcon = () => {
    switch (payment.status) {
      case "VERIFIED":
        return <CheckCircleIcon className="h-5 w-5 text-success" />;
      case "PENDING_REVIEW":
        return <ClockIcon className="h-5 w-5 text-warning" />;
      case "REJECTED":
        return <XCircleIcon className="h-5 w-5 text-danger" />;
      default:
        return null;
    }
  };

  return (
    <div
      onClick={onClick}
      className="bg-background border border-neutral-light rounded-lg p-4 hover:shadow-md cursor-pointer transition-shadow"
    >
      <div className="flex justify-between items-start mb-3">
        <div>
          <p className="text-sm font-medium text-text">
            {format(new Date(payment.dateCollected), "dd MMM yyyy")}
          </p>
          {showPlan && (
            <p className="text-xs text-neutral-dark">
              Plan: {payment.planId?.planNumber}
            </p>
          )}
        </div>
        {getStatusIcon()}
      </div>

      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <span className="text-sm text-neutral-dark">Amount:</span>
          <span className="font-medium text-text">
            ₹{payment.amountCollected?.toLocaleString()}
          </span>
        </div>
        
        {payment.verifiedAmount && payment.verifiedAmount !== payment.amountCollected && (
          <div className="flex justify-between items-center">
            <span className="text-sm text-neutral-dark">Verified:</span>
            <span className="font-medium text-success">
              ₹{payment.verifiedAmount?.toLocaleString()}
            </span>
          </div>
        )}
        
        <div className="flex justify-between items-center">
          <span className="text-sm text-neutral-dark">Method:</span>
          <span className="text-sm text-text">{payment.method}</span>
        </div>
        
        {payment.externalReference && (
          <div className="flex justify-between items-center">
            <span className="text-sm text-neutral-dark">Ref:</span>
            <span className="text-xs font-mono text-text">
              {payment.externalReference}
            </span>
          </div>
        )}
      </div>

      {payment.hasVariance && (
        <div className="mt-3 pt-3 border-t border-neutral-light">
          <p className="text-xs text-warning">
            ⚠️ Variance: {payment.variancePercent?.toFixed(1)}%
          </p>
        </div>
      )}
    </div>
  );
};

export default PaymentCard;
